// export const ApiUrl = "https://fimcstdb.zu.edu.ly";
export const ApiUrl = "http://localhost:2020";
